import CommonState from './CommonState'

export const OUT_FLIGHT = new CommonState('FLIGHT', '航班出运', 'Flight')
export const OUT_CUSTOMER = new CommonState('CUSTOMER', '客户自提', 'Customer')

export const WAREHOUSE_TYPES = [OUT_FLIGHT, OUT_CUSTOMER]
